"use client";

import type { PropsWithChildren } from "react";
import { Burger } from "~/components/icons/24/Burger";
import { Close } from "~/components/icons/24/Close";
import { Modal } from "~/components/ui/Modal";
import { menuModalName, useMenuModal } from "~/features/navigation/Header/useMenuModal";
import styles from "./header.module.css";

export const BurgerMenu = ({ children }: PropsWithChildren) => {
	const { isOpen, openModal, closeModal } = useMenuModal();
	return (
		<>
			<button
				className={`${styles.icon} ${styles.burger} ${isOpen ? styles.hidden : ""}`}
				onClick={openModal}
				aria-label="Open menu"
			>
				<Burger />
			</button>
			<button
				className={`${styles.icon} ${styles.close} ${!isOpen ? styles.hidden : ""}`}
				onClick={closeModal}
				aria-label="Close menu"
			>
				<Close />
				<Modal modalName={menuModalName} isMenu={true}>
					{children}
				</Modal>
			</button>
		</>
	);
};
